import type { ReactNode } from 'react'

/**
 * The frame every pre-authentication screen shares.
 *
 * Deliberately not the AppShell: nothing in the product's navigation should be
 * visible or reachable before a session exists, and reusing the shell here
 * would put a nav next to a login box.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: ReactNode
}) {
  return (
    <div className="grid min-h-screen place-items-center bg-surface-sunken px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-3">
          <img src="/blocwork-mark.png" alt="" aria-hidden width={36} height={36} className="h-9 w-9 rounded-lg" />
          <span className="text-xl font-semibold tracking-tight text-ink">Blocwork</span>
        </div>

        <div className="rounded-xl border border-line bg-surface-raised p-6 shadow-sm">
          <h1 className="text-lg font-semibold tracking-tight text-ink">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-ink-muted">{subtitle}</p> : null}
          <div className="mt-5">{children}</div>
        </div>
      </div>
    </div>
  )
}

export function FormError({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <p role="alert" className="mt-3 rounded-md border border-line bg-surface-sunken px-3 py-2 text-sm text-ink">
      {message}
    </p>
  )
}

export const inputClass =
  'w-full rounded-md border border-line bg-surface px-3 py-2 text-sm text-ink ' +
  'outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/30'

export const buttonClass =
  'w-full rounded-md bg-brand-900 px-3 py-2 text-sm font-semibold text-white ' +
  'hover:bg-brand-800 focus:outline-none focus:ring-2 focus:ring-brand-500/40 ' +
  'disabled:cursor-not-allowed disabled:opacity-60'
